module.exports = __webpack_public_path__ + "img/20200411110746193.4213a053.png";